import { useMemo } from "react";

const useGroupByRepayDate = (rows = []) => {
  return useMemo(() => {
    if (!rows || rows.length === 0) return [];

    const finalData = [];

    rows.forEach((item) => {
      finalData.push(item);

      if (item?.subtotalAmount != null && item?.subtotalDate) {
        finalData.push({
          isSubtotal: true,
          subtotalDate: item.subtotalDate,
          subtotalAmount: Number(item.subtotalAmount).toFixed(2)
        });
      }
    });

    return finalData;
  }, [rows]);
};

export default useGroupByRepayDate;
